import BaseApiAction from '@Actions/base-api-action';

export default class GetLeaderboard extends BaseApiAction {
    runAction() {
        super.invokeCloudFunction({
            name: 'stats-challengeBybIqFix-getLeaderboard',
            payload: {
                ...this.addFieldIfExists('score_field', this._payload.score_field),
                ...this.addFieldIfExists('score_type', this._payload.score_type),
                ...this.addFieldIfExists('from_date', this._payload.from_date),
                ...this.addFieldIfExists('to_date', this._payload.to_date),
                ...this.addFieldIfExists('period_type', this._payload.period_type),
                ...this.addFieldIfExists('previous_date', this._payload.previous_date),
                ...this.addFieldIfExists('offset', this._payload.offset),
                ...this.addFieldIfExists('limit', this._payload.limit),
                ...this.addFieldIfExists('play_position', this._payload.play_position),
                ...this.addFieldIfExists('game_mode', this._payload.game_mode),
                ...this.addFieldIfExists('session_type', this._payload.session_type),
                ...this.addFieldIfExists('is_completed', this._payload.is_completed),
                ...this.addFieldIfExists('skip_user_details', this._payload.skip_user_details),
                ...this.addFieldIfExists('user_id', this._payload.user_id),
                ...this.addFieldIfExists('challenge_id', this._payload.challenge_id),
                ...this.addFieldIfExists('playlist_id', this._payload.playlist_id),
                ...this.addFieldIfExists('country_code', this._payload.country_code),
                ...this.addFieldIfExists('continent_code', this._payload.continent_code),
                ...this.addFieldIfExists('age_group', this._payload.age_group),
            },
        });
    }
}
